(() => {
  const levels = {
    1: { rpm: "2,400", dba: "55", cfm: "46", note: "静かに蒸気とニオイを抑えます。" },
    2: { rpm: "3,200", dba: "61", cfm: "64", note: "グリルの煙を効率よくキャッチします。" },
    3: { rpm: "3,950", dba: "67", cfm: "82", note: "激しい油煙を逃さずパワフルに吸引します。" }
  };

  const formatCount = (value, decimals, grouping) => {
    return new Intl.NumberFormat("ja-JP", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
      useGrouping: grouping
    }).format(value);
  };

  const animateCount = (element) => {
    if (element.dataset.counted === "true") return;
    element.dataset.counted = "true";

    const target = Number(element.dataset.countTo);
    const decimals = Number(element.dataset.countDecimals || 0);
    const grouping = element.dataset.countGrouping === "true";
    const duration = 1400;

    if (!Number.isFinite(target) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      element.textContent = formatCount(target, decimals, grouping);
      return;
    }

    const start = window.performance.now();
    element.textContent = formatCount(0, decimals, grouping);

    const update = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = formatCount(target * eased, decimals, grouping);

      if (progress < 1) {
        window.requestAnimationFrame(update);
      } else {
        element.textContent = formatCount(target, decimals, grouping);
      }
    };

    window.requestAnimationFrame(update);
  };

  const initAirHood = (root) => {
    if (root.dataset.airhoodReady === "true") return;
    root.dataset.airhoodReady = "true";

    const productImage = root.querySelector("#ah2-product-image");
    const swatches = root.querySelectorAll(".ah2-swatch");

    const selectProductColor = (color) => {
      const target = [...swatches].find((swatch) => {
        const swatchColor = swatch.dataset.color ||
          (swatch.textContent || "").trim().toLowerCase();
        return swatchColor.includes(color);
      });

      if (!target) return;

      swatches.forEach((item) => {
        item.classList.remove("is-active");
        item.setAttribute("aria-pressed", "false");
      });
      target.classList.add("is-active");
      target.setAttribute("aria-pressed", "true");

      if (productImage && productImage.src !== target.dataset.src) {
        productImage.style.opacity = "0";
        window.setTimeout(() => {
          productImage.src = target.dataset.src;
          productImage.alt = target.dataset.alt;
          productImage.style.opacity = "1";
        }, 160);
      }
    };

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        const color = (swatch.dataset.color || swatch.textContent || "").trim().toLowerCase();
        selectProductColor(color.includes("black") ? "black" : "white");
      });
    });

    const levelButtons = root.querySelectorAll(".ah2-level");
    const rpm = root.querySelector("#ah2-rpm");
    const dba = root.querySelector("#ah2-dba");
    const cfm = root.querySelector("#ah2-cfm");
    const note = root.querySelector("#ah2-level-note");

    levelButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const value = levels[button.dataset.level];
        levelButtons.forEach((item) => {
          item.classList.remove("is-active");
          item.setAttribute("aria-selected", "false");
        });
        button.classList.add("is-active");
        button.setAttribute("aria-selected", "true");
        rpm.textContent = value.rpm;
        dba.textContent = value.dba;
        cfm.textContent = value.cfm;
        note.textContent = value.note;
      });
    });

    const variantSelect = root.querySelector(".ah2-variant-select");
    const price = root.querySelector(".ah2-live-price");
    const addButton = root.querySelector('button[name="add"]');

    if (variantSelect && price && addButton) {
      const syncSelectedVariant = () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        const available = option.dataset.available === "true";
        const sku = (option.dataset.sku || "").trim();
        const barcode = (option.dataset.barcode || "").trim();
        const title = (option.dataset.variantTitle || option.textContent || "").toLowerCase();

        price.textContent = option.dataset.price;
        addButton.disabled = !available;
        addButton.textContent = available ? "カートに追加する" : "売り切れ";

        if (
          sku === "4897109882905" ||
          barcode === "4897109882905" ||
          title.includes("ブラック") ||
          title.includes("black")
        ) {
          selectProductColor("black");
        } else if (title.includes("ホワイト") || title.includes("white")) {
          selectProductColor("white");
        }
      };

      variantSelect.addEventListener("change", syncSelectedVariant);
      syncSelectedVariant();
    }

    const counters = root.querySelectorAll(".ah2-countup");
    if ("IntersectionObserver" in window) {
      const counterObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCount(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.55 });

      counters.forEach((counter) => counterObserver.observe(counter));
    } else {
      counters.forEach(animateCount);
    }
  };

  document.querySelectorAll(".ah2").forEach(initAirHood);
  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll(".ah2").forEach(initAirHood);
  });
})();
